import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BackLinkProps {
  to: string;
  labelKey?: string;
}

export function BackLink({ to, labelKey = 'common.back' }: BackLinkProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-copper transition-colors mb-4"
    >
      ← {t(labelKey)}
    </button>
  );
}
